// src/AxiosJson.ts
import { Axios, AxiosHeaders } from "axios";
import { gzip } from "pako";
var AxiosJson = class _AxiosJson extends Axios {
  static defaultLogger;
  constructor(config) {
    super(_AxiosJson.axiosConfig(config));
  }
  static finalPath(response) {
    if (response.request.path) {
      return response.request.path.split("/").pop();
    } else if (response.request.responseURL) {
      return response.request.responseURL.split("/").pop();
    } else {
      this.defaultLogger?.warn("Failed to get final path from response");
    }
  }
  static axiosConfig({
    compressLength,
    headers,
    ...config
  } = {}) {
    return {
      headers: this.buildHeaders(headers),
      transformRequest: (data, headers2) => {
        const json = JSON.stringify(data);
        if (headers2 && data && json.length > (compressLength ?? 1024)) {
          headers2["Content-Encoding"] = "gzip";
          return gzip(json).buffer;
        }
        return json;
      },
      transformResponse: (data) => {
        try {
          return JSON.parse(data);
        } catch {
          return null;
        }
      },
      ...config
    };
  }
  static buildHeaders(headers) {
    const axiosHeaders = new AxiosHeaders();
    axiosHeaders.set("Accept", "application/json, text/plain, *.*");
    axiosHeaders.set("Content-Type", "application/json");
    for (const [key, value] of Object.entries(headers ?? {})) axiosHeaders.set(key, value);
    return axiosHeaders;
  }
};

// src/AxiosJsonUncompressed.ts
import { Axios as Axios2, AxiosHeaders as AxiosHeaders2 } from "axios";
var AxiosJsonUncompressed = class _AxiosJsonUncompressed extends Axios2 {
  static defaultLogger;
  constructor(config) {
    super(_AxiosJsonUncompressed.axiosConfig(config));
  }
  static finalPath(response) {
    if (response.request.path) {
      return response.request.path.split("/").pop();
    } else if (response.request.responseURL) {
      return response.request.responseURL.split("/").pop();
    } else {
      this.defaultLogger?.warn("Failed to get final path from response");
    }
  }
  static axiosConfig({ headers, ...config } = {}) {
    return {
      headers: this.buildHeaders(headers),
      transformRequest: (data) => {
        const json = JSON.stringify(data);
        return JSON.stringify(json);
      },
      transformResponse: (data) => {
        try {
          return JSON.parse(data);
        } catch {
          return null;
        }
      },
      ...config
    };
  }
  static buildHeaders(headers) {
    const axiosHeaders = new AxiosHeaders2();
    axiosHeaders.set("Accept", "application/json, text/plain, *.*");
    axiosHeaders.set("Content-Type", "application/json");
    for (const [key, value] of Object.entries(headers ?? {})) axiosHeaders.set(key, value);
    return axiosHeaders;
  }
};

// src/index.ts
import { gzip as gzip2 } from "pako";
var axios = new AxiosJson();
var axiosUncompressed = new AxiosJsonUncompressed();
export {
  AxiosJson,
  AxiosJsonUncompressed,
  axios,
  axiosUncompressed,
  gzip2 as gzip
};
//# sourceMappingURL=index.mjs.map